import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class MinimumValidationRule extends ValidationRule {
  private minimum: number;

  constructor(minimum: number, key: string | null = null) {
    if (!key) {
      key = ValidationTypes.minimum;
    }

    super(key);

    this.minimum = minimum;
  }

  isValid(value: any): boolean {
    if (value == null || isNaN(+value)) {
      return false;
    }
    return +value >= this.minimum;
  }
}
